import http from "@/http";

const login = async credentials => await http.post("/auth/login", credentials);

export default { login };
